import { Ref } from 'react';
import styles from './page-container.module.css';
import clsx from 'clsx';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}

export function PageContainer({ children, className, ref }: PageContainerProps) {
  return (
    <div ref={ref} className={clsx(styles.container, className)}>
      {children}
    </div>
  );
}
